module.exports = __webpack_public_path__ + "img/menu-food-2.9c23147f.webp";